export default __webpack_public_path__ + "static/media/Hemkunskap4.320dc9aa.jpeg";